import React, { FC } from "react";
import styled from "styled-components";
import Button from "../button";

export type ResourceBulkAction = {
  id: string;
  label: string;
  icon: string;
  onClick: () => void;
  disabled?: boolean;
  testId?: string;
};

type ResourceBulkActionsProps = {
  ariaLabel: string;
  actions: ResourceBulkAction[];
};

const Actions = styled.div`
  display: flex;
  flex: 0 0 auto;
  width: auto;
  min-width: 0;
  align-items: center;
  flex-wrap: nowrap;
  gap: 6px;

  @media (max-width: 768px) {
    flex: 0 0 auto !important;
    width: auto !important;
    flex-wrap: nowrap !important;
  }
`;

const ResourceBulkActions: FC<ResourceBulkActionsProps> = ({ ariaLabel, actions }) => {
  if (actions.length === 0) {
    return null;
  }

  return (
    <Actions role="toolbar" aria-label={ariaLabel}>
      {actions.map((action) => (
        <Button
          key={action.id}
          onClick={action.onClick}
          variant="icon"
          size="display"
          ariaLabel={action.label}
          test_id={action.testId}
          disabled={action.disabled}
        >
          <img alt="" src={action.icon}/>
        </Button>
      ))}
    </Actions>
  );
};

export default ResourceBulkActions;
